import React from 'react';
import { HelpCircle, Book, MessageCircle, Phone, FileText, X } from 'lucide-react';

interface HelpSupportProps {
  onClose: () => void;
}

export default function HelpSupport({ onClose }: HelpSupportProps) {
  const resources = [
    {
      title: 'Documentation',
      icon: Book,
      description: 'Browse detailed guides and documentation',
      link: '#'
    },
    {
      title: 'Live Chat',
      icon: MessageCircle,
      description: 'Chat with our support team',
      link: '#'
    },
    {
      title: 'Phone Support',
      icon: Phone,
      description: '24/7 phone support for urgent issues',
      link: '#'
    },
    {
      title: 'Knowledge Base',
      icon: FileText,
      description: 'Search our knowledge base for answers',
      link: '#'
    }
  ];

  const faqs = [
    {
      question: 'How do I start a new deal?',
      answer: 'Click the "New Deal" button in the sidebar to create a new deal. Fill in the required information and submit the form.'
    },
    {
      question: 'How can I manage document permissions?',
      answer: 'In the Data Room section, select a document and click the settings icon to manage permissions for different users and roles.'
    },
    {
      question: 'How do I set up email notifications?',
      answer: 'Go to Settings > Notifications to customize your email notification preferences for different types of updates.'
    }
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">Help & Support</h3>
          <button onClick={onClose}>
            <X className="w-5 h-5 text-gray-400 hover:text-gray-600" />
          </button>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-2 gap-6 mb-8">
            {resources.map((resource) => (
              <div
                key={resource.title}
                className="p-4 border border-gray-200 rounded-lg hover:border-blue-500 transition-colors cursor-pointer"
              >
                <div className="flex items-center mb-2">
                  <resource.icon className="w-5 h-5 text-blue-600 mr-2" />
                  <h4 className="text-base font-medium text-gray-900">{resource.title}</h4>
                </div>
                <p className="text-sm text-gray-600">{resource.description}</p>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-200 pt-6">
            <h4 className="text-base font-medium text-gray-900 mb-4 flex items-center">
              <HelpCircle className="w-5 h-5 mr-2" />
              Frequently Asked Questions
            </h4>
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="border-b border-gray-200 pb-4">
                  <h5 className="text-sm font-medium text-gray-900 mb-2">{faq.question}</h5>
                  <p className="text-sm text-gray-600">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-6 bg-blue-50 p-4 rounded-lg">
            <h4 className="text-sm font-medium text-blue-900 mb-2">Need more help?</h4>
            <p className="text-sm text-blue-700">
              Our support team is available 24/7. Contact us at support@company.com or call +1 (555) 123-4567.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}